import * as RadixUiCollapsible from "@radix-ui/react-collapsible";
import classNames from "classnames";
import React from "react";

const classNamePrefix = "Accordion";

type AccordionProps = Omit<RadixUiCollapsible.CollapsibleProps, "title"> & {
  icon?: React.ReactNode;
  stat?: React.ReactNode;
  title: React.ReactNode;
  titleAs?: "h1" | "h2" | "h3" | "h4" | "h5";
  titleProps?: React.HTMLAttributes<HTMLHeadingElement>;
  triggerLabel?: string;
};

export const Accordion = React.forwardRef(
  (props: AccordionProps, ref?: React.ForwardedRef<HTMLDivElement>) => {
    const {
      children,
      className,
      defaultOpen,
      icon,
      stat,
      title,
      titleAs: Title = "h2",
      titleProps,
      triggerLabel = "Ouvrir/Fermer",
      ...restProps
    } = props;
    return (
      <RadixUiCollapsible.Root
        ref={ref}
        {...restProps}
        className={classNames(className, classNamePrefix)}
        data-icon={icon ? true : undefined}
        defaultOpen={defaultOpen}
      >
        <div className={`${classNamePrefix}-header`}>
          <div>
            {icon && <div className={`${classNamePrefix}-icon`}>{icon}</div>}
            <Title {...titleProps} className={`${classNamePrefix}-title`}>
              {title}
            </Title>
          </div>
          <div>
            {stat && <div className={`${classNamePrefix}-stat`}>{stat}</div>}
            {!defaultOpen && (
              <RadixUiCollapsible.Trigger
                aria-label={triggerLabel}
                className={`${classNamePrefix}-trigger`}
              />
            )}
          </div>
        </div>
        <RadixUiCollapsible.Content className={`${classNamePrefix}-body`}>
          {children}
        </RadixUiCollapsible.Content>
      </RadixUiCollapsible.Root>
    );
  },
);
